<template>
	<div class="job-description">
		<form>
			<div class="job-description-header">
				<h2>Job Title: {{ job.job_title }}</h2>
				<!-- <h5>{{ job.publication_name }}</h5> -->
				<div class="content-group" v-if="job.booking_number || job.publication_name">
					<p class="col-sm-6" v-if="job.booking_number">Booking Number: {{ job.booking_number }}</p>
					<p class="col-sm-6" v-if="job.publication_name">Publication Name: {{ job.publication_name }}</p>
				</div>
			</div>
			<div class="job-description-body">
				<div class="job-description-body-content">
					<div class="content-group">
						<p class="col-sm-6">Job Id: {{ job.job_id }}</p>
						<p class="col-sm-6">Job Type: {{ job.job_type }}</p>
					</div>
					<div class="content-group">
						<p class="col-sm-6">Publication Type: {{ job.publication_type }}</p>
						<p class="col-sm-6">Colour Mode: {{ job.colour_mode }}</p>
					</div>
					<div class="content-group" v-if="job.print_width || job.print_width">
						<p class="col-sm-6" v-if="job.print_width">Print Width(mm): {{ job.print_width }}</p>
						<p class="col-sm-6" v-if="job.print_depth">Print Depth(mm): {{ job.print_depth }}</p>
					</div>
					<div class="content-group" v-if="job.bleed_width || job.bleed_width">
						<p class="col-sm-6" v-if="job.bleed_width">Bleed Width(mm): {{ job.bleed_width }}</p>
						<p class="col-sm-6" v-if="job.bleed_depth">Bleed Depth(mm): {{ job.bleed_depth }}</p>
					</div>
					<div class="content-group" v-if="job.web_width || job.web_width">
						<p class="col-sm-6" v-if="job.web_width">Web Width(mm): {{ job.web_width }}</p>
						<p class="col-sm-6" v-if="job.web_depth">Web Depth(mm): {{ job.web_depth }}</p>
					</div>
					<div class="content-group">
						<P class="col-sm-6">Client Name: {{ job.client_name }}</P>
						<p class="col-sm-6">Client Email: {{ job.client_email }}</p>
					</div>
					<div class="content-group">
						<P class="col-sm-6">Contact Number: {{ job.contact_number }}</P>
						<p class="col-sm-6">Company Name: {{ job.company_name }}</p>
					</div>
					<div
						class="content-group"
						v-if="
							job.deadline !== 'None' || job.run_date !== 'None'
						"
					>
						<P class="col-sm-6" v-if="job.deadline !== 'None'">Deadline: {{ job.deadline }}</P>
						<p class="col-sm-6" v-if="job.run_date !== 'None'">Run Date: {{ job.run_date }}</p>
					</div>

					<p>Description: {{ job.instructions }}</p>
				</div>
				<div
					v-if="job.attachments && job.attachments.length > 0"
					class="job-description-body-attachments"
				>
					<BaseAttachment :attachments="job.attachments" :isCreate="false"/>
				</div>
			</div>
			<div class="job-description-footer">
				<div
					class="job-description-footer-button"
					v-if="job.attachments && job.attachments.length > 0"
					@click.prevent="clickDownloadAll"
				>Download All Files</div>
				<div
					class="job-description-footer-button"
					@click.prevent="clickTakeOwnership"
					v-if="isTakeOwnershipButton"
				>Take Ownership</div>
				<div
					class="job-description-footer-button"
					v-if="!isCompleted && isApproved && isStaff"
					@click.prevent="clickComplete"
				>Complete</div>
			</div>
		</form>
	</div>
</template>

<script>
import { mapState } from 'vuex'
import { isStaff, attachmentOriginalName, fetchFile } from '@/utils/Help.js'
import NProgress from 'nprogress'
import { getDownloadSignedUrl } from '@/services/S3Service.js'
import JSZip from 'jszip'
import { saveAs } from 'file-saver'

export default {
	name: 'JobDescription',
	computed: {
		...mapState({
			job: state => state.job.job
		}),
		isStaff() {
			return isStaff()
		},
		isTakeOwnershipButton() {
			return (
				!this.isMyJob &&
				this.isStaff &&
				!this.isCompleted &&
				!this.isApproved
			)
		},
		isMyJob() {
			const jobStaffEmail = this.job.staff_email
			const user = JSON.parse(sessionStorage.getItem('user'))
			const { email, profile } = user
			let isMyJob = false
			if (profile === 'Staff') {
				isMyJob = email === jobStaffEmail ? true : false
			}
			return isMyJob
		},
		isCompleted() {
			return this.job.job_status === 'completed' ? true : false
		},
		isApproved() {
			const job_status = this.job.job_status
			const isApproved = job_status === 'approved' ? true : false
			return isApproved
		},
		isCompleteButton() {
			return !this.isCompleted && this.isApproved && this.isStaff
		}
		// isButtonGroup() {
		// 	return !(this.isCompleted && !this.isTakeOwnership)
		// }
	},
	methods: {
		async clickComplete() {
			try {
				NProgress.start()
				await this.$store.dispatch('job/completeJob', {
					job_id: this.job.job_id
				})
				NProgress.done()
			} catch (e) {
				console.log(e)
				NProgress.done()
			}
		},
		async clickTakeOwnership() {
			try {
				NProgress.start()
				const user = JSON.parse(sessionStorage.getItem('user'))
				const staff_email = user.email
				const staff_name = user.name
				const job_status = 'processing'
				await this.$store.dispatch('job/acceptJob', {
					job_id: this.job.job_id,
					staff_name,
					staff_email,
					job_status
				})
				NProgress.done()
			} catch (e) {
				console.log(e)
				NProgress.done()
			}
		},
		async clickDownloadAll() {
			NProgress.start()
			let zip = new JSZip()
			const token = sessionStorage.getItem('token')
			const attachments = this.job.attachments
			for (let i = 0; i < attachments.length; i++) {
				const folder = attachments[i].folder
				const name = attachments[i].name
				const fileName = attachmentOriginalName(name)

				try {
					const response = await getDownloadSignedUrl(
						folder,
						name,
						token
					)
					const URL = response.data.url

					const blob = await fetchFile(URL)
					zip.file(fileName, blob)
				} catch (e) {
					NProgress.done()
					console.log(e)
					const notification = {
						type: 'error',
						message: `Oops! Something went wrong.`
					}

					this.$store.dispatch('notification/add', notification, {
						root: true
					})
				}
			}
			zip.generateAsync({ type: 'blob' }).then(function(content) {
				saveAs(content, 'Attachments.zip')
			})
			NProgress.done()
		}
	}
}
</script>

<style lang="scss" scoped>
@import '../styles/components/jobDescription.scss';
</style>
